import { TestClient } from 'apps/studio/components/test/testClient'
import { PDFPreview } from 'apps/studio/components/test/pdfPreview'

export const Test = () => (
  <div className="test--mode">
    <TestClient />
    <PDFPreview />
  </div>
)
